import { FC } from 'react';

import { push } from 'connected-react-router';
import { CAMPAIGNS_DASHBOARD_PAGE_ROUTE } from 'utils/constants/app';
import { PAGE_SIZE } from 'utils/constants/campaign';

import { Flex, NumberPages, VSpacing } from '@hh.ru/magritte-ui';

import { useDispatch, useSelector } from 'store/utils';

export const CampaignsPagination: FC = () => {
    const { campaignsCurrentPage, campaignsCurrentTab, campaignsCounts } = useSelector(
        (state) => state.campaignsDashboard
    );

    const totalPages = Math.ceil(campaignsCounts[campaignsCurrentTab] / PAGE_SIZE);

    const dispatch = useDispatch();

    if (totalPages <= 1 || campaignsCurrentPage > totalPages) {
        return <VSpacing default={40} />;
    }

    const handlePageChange = (newPageNumber: number) => {
        dispatch(push(`${CAMPAIGNS_DASHBOARD_PAGE_ROUTE}${campaignsCurrentTab}?page=${newPageNumber}`));
    };

    return (
        <>
            <VSpacing default={40} />
            <Flex justify="center">
                <NumberPages first={1} last={totalPages} current={campaignsCurrentPage} onChange={handlePageChange} />
            </Flex>
            <VSpacing default={40} />
        </>
    );
};
